// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"7e412b64","210":"c551420f","339":"2f34b638","638":"d514af62","906":"b608ec3f","955":"79139d10","958":"d5d5ecb2","995":"207c5da0"}[chunkId] + ".chunk.js";
};